<template>
<div id="projectDetail">
    <mProjectDetail v-if="$store.state.device == 'mob'" />
    <pProjectDetail v-if="$store.state.device == 'pc'" />
</div>
</template>

<script>
import mProjectDetail from '@/components/mProjectDetail.vue'
import pProjectDetail from '@/components/pProjectDetail.vue'

export default {
    name: 'ProjectDetail',
    data (){
        return {

        }
    },
    components: {
        mProjectDetail,
        pProjectDetail,
    },
    computed: {

    },
    methods: {

    },
    mounted () {

    }
}
</script>

<style lang="scss" scoped>

</style>
